export default __webpack_public_path__ + "static/media/ozkey_web.61bc98e9.png";